import React, { Component } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";

// Components
import BodyWrap from "../utils/BodyWrap";
import ContentDiv from "../utils/ContentDiv";
import GeneralLoader from "../GeneralLoader";
import SectionFooter from "../utils/SectionFooter";
import ReviewSearch from "./review-search/ReviewSearch";
import SectionBanner from "../utils/SectionBanner";
import ReviewPreview from "./ReviewPreview";

// CSS
import "../../css/reviews/review-page.css";
import "../../css/reviews/reviews-search.css";

// State
import { getTranslations } from "../../store/actions/translations";
import { getReviews, getRelatedReviews, reviewsResetState } from "../../store/actions/reviews";
import { getReviewerReviews } from "../../store/actions/user";

class Reviews extends Component {
	static initialAction(store, props, translationKey = null) {
		const promises = [];
		const translationSections = ["reviews", "buttons", "review_registration_dialog"];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		let resTranslations =
			store !== null
				? getTranslations([translationKey], translationSections, translationKey)
				: props.getTranslations([translationKey], translationSections, translationKey);
		promises.push(resTranslations);

		return promises;
	}

	static userActions(store, props) {
		const promises = [];

		if (store !== null) {
			promises.push(getReviews(null, null, 4));
			promises.push(getRelatedReviews(4));
			promises.push(getReviewerReviews());
		} else {
			promises.push(props.getReviews(null, null, 4));
			promises.push(props.getRelatedReviews(4));
			promises.push(props.getReviewerReviews());
		}

		return promises;
	}

	componentWillMount() {
		// Regardless, we will want to go grab updated reviews info since this won't be loaded in SSR
		Reviews.userActions(null, this.props);

		// Grab translations if not already in store
		if (!this.props.translations.pages[this.props.translationKey]) {
			Reviews.initialAction(null, this.props);
		}
	}

	componentWillUnmount() {
		this.props.reviewsResetState();
	}

	render() {
		const {
			translationsLoading,
			translations,
			relatedReviewsIsLoading,
			relatedReviews,
			allReviewsIsLoading,
			allReviews,
			userReviewsLoading,
			activeReviews,
			search
		} = this.props;

		// ===================================
		//	HELMET STUFF
		// ===================================
		let helmet = null;

		let title = "";
		if (this.props.siteInfo.site) {
			title += this.props.siteInfo.site.title;
		}
		if (!!translations.pages[this.props.translationKey]) {
			if (title !== "") title += " | ";
			title += translations.pages[this.props.translationKey].title;
		}

		// helmet = (
		// 	<Helmet>
		// 		<title>{title}</title>
		// 		<meta property="og:title" content={title} />
		// 		<meta property="og:description" content={title} />
		// 		<meta property="twitter:title" content={title} />
		// 	</Helmet>
		// );

		return (
			<BodyWrap>
				{/* {helmet} */}
				<main>
					<div className="page-content">
						<div className="section-row">
							<div className="section section-2--main">
								{translationsLoading ? (
									<GeneralLoader />
								) : !!translations.pages[this.props.translationKey] ? (
									<ContentDiv>
										{translations.pages[this.props.translationKey].content}
									</ContentDiv>
								) : null}
							</div>
							{!translationsLoading && (
								<div className="section section-2--side">
									<SectionFooter href="/reviews/related">
										{translations.sections.reviews.view_my_reviews_link}
									</SectionFooter>
									<ReviewSearch types={["related", "all"]} />
								</div>
							)}
						</div>
						{!translationsLoading && (
							<React.Fragment>
								<div className="section-row section-row--block">
									<div className="section-content pt0 pb0">
										<SectionBanner
											link={{
												href: `/reviews/related`,
												title:
													translations.sections.reviews
														.matched_reviews_link
											}}
										>
											{translations.sections.reviews.matched_reviews_title}
										</SectionBanner>

										{relatedReviewsIsLoading ||
											userReviewsLoading ||
											search.inProgress ? (
												<GeneralLoader />
											) : (
												<div className="preview-area pt1">
													{relatedReviews.length ? (
														relatedReviews.map((review, i) => (
															<ReviewPreview
																key={i}
																review={review}
																activeReviews={activeReviews}
															/>
														))
													) : (
															<div>
																{
																	translations.sections.reviews
																		.no_reviews_search_response
																}
															</div>
														)}
												</div>
											)}
									</div>
								</div>
								<div className="section-row section-row--block">
									<div className="section-content pt0 pb0">
										<SectionBanner
											link={{
												href: `/reviews/all`,
												title:
													translations.sections.reviews.all_reviews_link
											}}
										>
											{translations.sections.reviews.all_reviews_title}
										</SectionBanner>

										{allReviewsIsLoading ||
											userReviewsLoading ||
											search.inProgress ? (
												<GeneralLoader />
											) : (
												<div className="preview-area pt1">
													{allReviews.length ? (
														allReviews.map((review, i) => (
															<ReviewPreview key={i} review={review} />
														))
													) : (
															<div>
																{
																	translations.sections.reviews
																		.no_reviews_search_response
																}
															</div>
														)}
												</div>
											)}
									</div>
								</div>
							</React.Fragment>
						)}
					</div>
				</main>
			</BodyWrap>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		siteInfo: state.siteInfo,
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations,
		content: state.content,
		relatedReviewsIsLoading:
			state.reviews.relatedIsLoading !== undefined ? state.reviews.relatedIsLoading : 1,
		relatedReviews: state.reviews.relatedReviews,
		allReviewsIsLoading: state.reviews.isLoading !== undefined ? state.reviews.isLoading : 1,
		allReviews: state.reviews.reviews,
		// allReviews: state.reviews,
		userReviewsLoading:
			state.user.reviewerReviewsLoading !== undefined ? state.user.reviewerReviewsLoading : 1,
		search: state.reviewSearch
	};
};

export default connect(
	mapStateToProps,
	{ getTranslations, getRelatedReviews, getReviews, getReviewerReviews, reviewsResetState }
)(Reviews);



// WEBPACK FOOTER //
// ./src/components/reviews/Reviews.js